import { useState } from "react";
import crossIcon from "../../assets/icons/cross-Icon.png";

const TagInput = ({
  limit,
  inputBgColor = "white",
  textColor = "black",
  tagColor = "blue",
  tagTextColor = "black",
  placeholder = "",
  className = "",
  width = "",
  tagClassName = "",
  overLimitMessage = "Tag Limit Exceeded",
  onChange,
}) => {
  const [tags, setTags] = useState([]);
  const [value, setValue] = useState("");

  const addTag = (e) => {
    if (e.key === "Enter") {
      if (limit === tags.length) {
        return;
      }
      if (value.length <= 0) {
        return;
      }
      const nextTags = [...tags, value];
      setTags(nextTags);
      onChange?.(nextTags);
      setValue("");
    }
  };

  const removeTag = (key) => {
    const nextTags = tags.filter((_, idx) => idx !== key);
    setTags(nextTags);
    onChange?.(nextTags);
  };

  return (
    <>
      <div
        className={`d-flex p-2  rounded-2 gap-2 tag-input-div flex-wrap  ${className}`}
        style={{ backgroundColor: inputBgColor, width: width }}
      >
        <div className="d-flex gap-1 overflow-auto">
          {tags.map((tag, key) => (
            <div
              className={`d-flex justify-content-between gap-2 align-items-center p-2 rounded-3  ${tagClassName}`}
              style={{ backgroundColor: tagColor, color: tagTextColor }}
            >
              <span>{tag}</span>
              <img
                src={crossIcon}
                alt="del"
                width={10}
                height={10}
                className="cursor-pointer"
                onClick={() => removeTag(key)}
              />
            </div>
          ))}
        </div>

        <input
          type="text"
          className="bg-transparent w-100 taginput "
          style={{ color: textColor, border: "none" }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => addTag(e)}
          placeholder={limit === tags.length ? overLimitMessage : placeholder}
          disabled={limit === tags.length}
        />
      </div>
    </>
  );
};

export default TagInput;
